
require.register("axios/lib/env/data.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "axios");
  (function() {
    module.exports = {
  "version": "0.27.2"
};
  })();
});